import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Navbar } from '../components/senior-living/Navbar';
export function ThankYou() {
  return <div className="flex min-h-screen w-full flex-col bg-[var(--color-navy)]" data-id="element-144" data-mp="2jrpzvfhc7v72">
      <Navbar showActions={false} data-id="element-145" data-mp="2jtsu6bpiwahl" />
      <main className="flex flex-1 items-center justify-center" data-id="element-146" data-mp="2orccbmpcd7et">
        <div className="mx-auto w-full max-w-3xl px-4 py-20 text-center sm:px-6 sm:py-28 lg:px-8" data-id="element-147" data-mp="2oogcttxuiao9">
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-lime)]" data-id="element-148" data-mp="2to2zsv3h75a9">
            <CheckIcon className="h-8 w-8 text-[var(--color-navy)]" strokeWidth={3} aria-hidden="true" data-id="element-149" data-mp="3cgx670n19p2v" />
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          delay: 0.1,
          ease: 'easeOut'
        }} className="font-display mt-8 text-white" data-id="element-150" data-mp="3hg9snk9zsu4x">
            <span className="block text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-151" data-mp="1y6ydb3e8cxcs">
              Thank You
            </span>
            <span className="mt-3 block text-xl font-semibold text-white/85 sm:text-2xl" data-id="element-152" data-mp="1u7pkq1uxf5it">
              We Received Your Request
            </span>
          </motion.h1>
        </div>
      </main>
    </div>;
}